import { queryOptions } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { QueryFunctionContext } from '@tanstack/react-query';

export interface ActionsTypeEntry {
  id: string;
  name: string;
  level: string;
}

export const getActionsType = async ({ signal }: QueryFunctionContext<[string]>): Promise<ActionsTypeEntry[]> => {
  const res = await apiClient.get<ActionsTypeEntry[]>(`/action_types`, {
    signal,
  });
  return res.data;
};

export const facebookActionTypesOptions = queryOptions({
  staleTime: 60 * 30 * 1000,
  queryFn: getActionsType,
  queryKey: ['action_types'],
});
